module.exports = __webpack_public_path__ + "img/蒙版右.574e53bd.png";